export default __webpack_public_path__ + "static/media/bosch_ui_icon.7edf5ebb.woff";